import {
    QueryFileByIdUsingGetParams,
    FileVo,
    QueryFolderIdStyleCodeUsingGetParams,
    StyleCodeAndCloudId,
    AddDirParam,
    ListAllQueryParam,
    LinkFileQueryParam,
    ParentIdParam,
    DirVo,
    ListQueryParam,
    UpdateNameParam,
    SignatureVo,
    CheckDirNameParam,
    IdVo,
    StorageVo,
    ReferralsDiskFolderResult,
    DownloadDiskParam,
    DownloadFileVo,
    QueryGoodsImgUsingGetParams,
    QueryGoodsImgResult,
    ModifyPhotoParam,
    GoodsMatchFolderParam,
    DownloadLogQueryParam,
    CloudDiskDownloadLog,
    CoIdAndFileIdVo,
    ParentIdChannelParam,
    ListChannelQueryParam,
    CheckDownloadParam,
    IdsVo,
    QueryParentTreeUsingGetParams,
    MoveFileParam,
    MoveFileResult,
    CoIdAndSpuId
} from '@servicesTypings/goodsRequest'
import { goodsRequest } from '@/utils/request'

// 根据资料编码获取推荐的素材文件夹
/**
 * 根据文件id查询
 */
export function queryFileById(params: QueryFileByIdUsingGetParams): API.Res<FileVo> {
    return goodsRequest.get('/cloud/disk/queryFileById', { params })
}

// 获取资料编码和关联的素材id
/**
 * 获取资料编码和关联的素材id
 */
export function queryFolderIdStyleCode(params: QueryFolderIdStyleCodeUsingGetParams): API.Res<StyleCodeAndCloudId> {
    return goodsRequest.get('/cloud/disk/queryFolderIdStyleCode', { params })
}

// 根据资料编码获取推荐的素材文件夹
export function queryMatchFolder(data) {
    const { sort } = data || {}

    // 没法子排序规则不一样，不知道怎么处理，直接在这里截取吧
    const newSort = typeof sort === 'string' ? sort.replace('FILE_TYPE ASC, ', '') : ''

    return goodsRequest.post('/cloud/disk/queryMatchFolder', {
        data: {
            ...(data || {}),
            sort: newSort
        }
    })
}
// 添加文件夹
/**
 * 添加文件夹
 */
export function addDir(data: AddDirParam): API.Res<object> {
    return goodsRequest.post('/cloud/disk/addDir', { data })
}

// 添加文件夹
/**
 * 查询全部文件列表
 */
export function queryAllList(data: ListAllQueryParam): API.Res<FileVo[]> {
    return goodsRequest.post('/cloud/disk/queryAllList', { data })
}

// 根据文件ID生成分享链接的key
/**
 * 根据文件ID生成分享链接的key
 */
export function getShareKey(data: string[]): API.Res<string> {
    return goodsRequest.post('/cloud/disk/share/createLink', { data })
}

// 根据文件ID生成分享链接的key
/**
 * 根据唯一key查询文件列表
 */
export function getShareFileList(data: LinkFileQueryParam): API.Res<FileVo[]> {
    return goodsRequest.post('/cloud/disk/share/getLinkFileList', { data })
}

// 根据文件ID列表删除文件
/**
 * 根据文件ID列表删除文件
 */
export function delFileList(data: string[]): API.Res<object> {
    return goodsRequest.post('/cloud/disk/delFileList', { data })
}

// 查询子文件夹列表
/**
 * 查询子文件夹列表
 */
export function queryChildDirList(data: ParentIdParam): API.Res<DirVo[]> {
    return goodsRequest.post('/cloud/disk/queryChildDirList', { data })
}

// 查询文件列表
/**
 * 查询文件列表
 */
export function queryList(data: ListQueryParam): API.Res<FileVo[]> {
    return goodsRequest.post('/cloud/disk/queryList', { data })
}

// 修改文件名称
/**
 * 修改文件名称
 */
export function updateFileName(data: UpdateNameParam): API.Res<object> {
    return goodsRequest.post('/cloud/disk/updateFileName', { data })
}

// 获取签名
/**
 * 获取授权信息
 */
export function getSignature(): API.Res<SignatureVo> {
    return goodsRequest.post('/cloud/disk/getSignature')
}

// 添加文件
export function addFile(data, { signal }) {
    return goodsRequest.post('/cloud/disk/addFile', {
        data,
        signal
    })
}

// 检测文件夹
/**
 * 当前文件夹内文件名称效验
 */
export function checkDirNameRepeat(data: CheckDirNameParam): API.Res<object> {
    return goodsRequest.post('/cloud/disk/checkDirNameRepeat', { data })
}

// 查询资料编码
/**
 * 查询资料编码
 */
export function queryStyleCode(data: IdVo): API.Res<string> {
    return goodsRequest.post('/myself/rapidly/goods/queryStyleCode', { data })
}

/**
 * 获取容量信息
 */
export function getStorage(): API.Res<StorageVo> {
    return goodsRequest.get('/cloud/disk/storage/getStorage')
}

// 获取推荐结果
/**
 * 查询文件列表
 */
export function queryReferralsResult(data: string[]): API.Res<ReferralsDiskFolderResult[]> {
    return goodsRequest.post('/cloud/disk/queryReferralsResult', { data })
}

// 查询目录下的所有文件
/**
 * 云盘素材下载操作
 */
export function queryAllFiles(data: DownloadDiskParam): API.Res<DownloadFileVo[]> {
    return goodsRequest.post('/cloud/disk/download', { data })
}

// 查询商品规格与图片
/**
 * 查询商品图片
 */
export function queryGoodsImg(params: QueryGoodsImgUsingGetParams): API.Res<QueryGoodsImgResult> {
    return goodsRequest.get('/supplier/goods/queryGoodsImg', { params })
}

// 修改图片
/**
 * 修改相册
 */
export function modifyImage(data: ModifyPhotoParam): API.Res<object> {
    return goodsRequest.post('/supplier/goods/modifyImage', { data })
}

//   商品关联素材包
/**
 * 商品关联素材包
 */
export function goodsBindFolder(data: GoodsMatchFolderParam[]): API.Res<ReferralsDiskFolderResult[]> {
    return goodsRequest.post('/cloud/disk/goodsBindFolder', { data })
}

// 查询下载日志
/**
 * 云盘素材下载日志列表
 */
export function queryMaterialDownloadLogList(data: DownloadLogQueryParam): API.Res<CloudDiskDownloadLog[]> {
    return goodsRequest.post('/cloud/disk/downloadLog/list', { data })
}

//  =======  新接口，老接口有限制只能查看自己的，现在分销商需要查看供应商的素材  =======
// 查文件
/**
 * 查询单个文件
 */
export function queryChannelFileById(data: CoIdAndFileIdVo): API.Res<FileVo> {
    return goodsRequest.post('/cloud/disk/channel/queryFile', { data })
}

// 查询子文件夹列表
/**
 * 查询子文件夹列表
 */
export function queryChannelChildDirList(data: ParentIdChannelParam): API.Res<DirVo[]> {
    return goodsRequest.post('/cloud/disk/channel/queryChildDirList', { data })
}

// 查询子文件夹列表
/**
 * 查询文件列表
 */
export function queryChannelList(data: ListChannelQueryParam): API.Res<FileVo[]> {
    return goodsRequest.post('/cloud/disk/channel/queryList', { data })
}

// =================

// 检查是否可下载
/**
 * 云盘素材是否允许下载
 */
export function allowDownload(data: CheckDownloadParam): API.Res<boolean> {
    return goodsRequest.post('/cloud/disk/download/allowDownload', { data })
}

// 解绑
/**
 * 批量解除素材关联
 */
export function batchRemoveCloudDiskFolder(data: IdsVo): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchRemoveCloudDiskFolder', { data })
}

// 查询文件的父文件夹的全路径树结构
/**
 * 查询文件的父文件夹的全路径树结构
 */
export function queryParentTree(params: QueryParentTreeUsingGetParams): API.Res<DirVo[]> {
    return goodsRequest.get('/cloud/disk/queryParentTree', { params })
}

// 移动图片/文件夹目录
/**
 * 移动文件
 */
export function moveFile(data: MoveFileParam): API.Res<MoveFileResult> {
    return goodsRequest.post('/cloud/disk/moveFile', { data })
}

// 下载数据包
/**
 * 下载资料包
 */
export function downloadGoodsDetail(data: CoIdAndSpuId[]): API.Res<string> {
    return goodsRequest.post('/goods/downloadGoodsDetail', { data })
}

// 查询供应商素材
/**
 * 获取供应商资料编码和关联的素材id
 */
export function querySupplierFolderIdStyleCode(data: CoIdAndSpuId): API.Res<StyleCodeAndCloudId> {
    return goodsRequest.post('/cloud/disk/querySupplierFolderIdStyleCode', { data })
}

// 根据供应商spuId查询自己的spuId
/**
 * 根据供应商商品ID获取对应的自己的商品ID
 */
export function querySpuIdBySupplierSpuId(data: CoIdAndSpuId): API.Res<string> {
    return goodsRequest.post('/supplier/goods/querySpuIdBySupplierSpuId', { data })
}
